module.exports = __webpack_public_path__ + "static/media/014_IMG_1208.8fa000ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/014_IMG_1208.png
// module id = 561
// module chunks = 0